import type { NgDocCategory } from '@ng-doc/core';

const DirectivesCategory: NgDocCategory = {
  order: 3,
  title: 'Directives'
};

export default DirectivesCategory;